/*
  log actions are sent to Redux Sagas located in:
  packages\tracs\src\redux\log\saga.js
*/
const actions = {
  LOG_FIELDS: 'LOG_FIELDS',
  LOG_FIELDS_SUCCESS: 'LOG_FIELDS_SUCCESS',
  LOGS: 'LOGS',
  LOG_SUCCESS: 'LOG_SUCCESS',
  LOG_ERROR: 'LOG_ERROR',

  //rest of user editor options
  apiLogs: queryString => ({
    type: actions.LOGS,
    queryString,
  }),

  apiLogFields: () => ({
    type: actions.LOG_FIELDS,
  }),
};
export default actions;
